<template>
  <div>
    <div class="mainContent startShowCredentialsDiv">
      <div class="mainContent__paragraphs">
        <p>
          Esses são os dados que a transportadora utilizará para acessar o FTP da Intelipost.
        </p>
      </div>

    <div v-if="credentials" class="mainContent__data">

      <div class="mainContent__andress">
        <strong> Endereço do SFTP: </strong>
        <sc-field>
          <sc-input class="mainContent__input" :value="credentials.ftp.host" id="andress" readonly expanded/>

          <p class="control">
            <sc-tooltip label="Copiar" position="is-bottom">
              <sc-button
                id="copy-target-content"
                theme="primary"
                icon="copy"
                :text="copyText"
                :disabled="!!copyText"
                data-clipboard-target="#andress"/>
              </sc-tooltip>
            </p>
        </sc-field>
      </div>


      <div class="mainContent__user">
        <strong> Usuário do SFTP: </strong>
        <sc-field>
          <sc-input class="mainContent__input" :value="credentials.ftp.username" id="userFtp" readonly expanded/>

          <p class="control">
            <sc-tooltip label="Copiar" position="is-bottom">
              <sc-button
                id="copy-target-content"
                theme="primary"
                icon="copy"
                :text="copyText"
                :disabled="!!copyText"
                data-clipboard-target="#userFtp"/>
              </sc-tooltip>
            </p>
        </sc-field>
      </div>

      <div class="mainContent__password">
        <strong> Senha do SFTP: </strong>
        <sc-field>
          <sc-input class="mainContent__input" :value="credentials.ftp.password" id="password" readonly/>

          <p class="control">
            <sc-tooltip label="Copiar" position="is-bottom">
              <sc-button
                id="copy-target-content"
                theme="primary"
                icon="copy"
                :text="copyText"
                :disabled="!!copyText"
                data-clipboard-target="#password"/>
              </sc-tooltip>
            </p>
        </sc-field>
      </div>
    </div>

      <div class="mainContent__folders">
        <h1><strong> Pastas criadas: </strong></h1>
        <h2>/OCOREN</h2>
        <h2>/CTE</h2>
        <h2>/CONEMB</h2>
        <h2>/DOCCOB</h2>
      </div>
    </div>
    <help-button/>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScField,
    ScIcon,
    ScInput,
    ScTooltip,
  } from '@intelipost-js/secure-components';
  import { Clipboard } from '@intelipost-js/secure-providers';

  import HelpButton from './base/HelpButton.vue';

  const { mapActions, mapMutations } = createNamespacedHelpers('integrations/integrationsAppSelfService');

  export default {
    name: 'sc-show-credentials',
    components: {
      ScButton,
      ScField,
      ScIcon,
      ScInput,
      ScTooltip,
      HelpButton,
    },
    data() {
      return {
        copyText: '',
        credentials: null,
      };
    },
    mounted() {
      this.clipboard = new Clipboard('#copy-target-content');
      this.clipboard.on('sucess', () => {
        this.copyText = 'Copiado para sua área de transferência!';
        setTimeout(() => {
          this.copyText = null;
        }, 1000);
      });
    },
    destroyed() {
      if (this.clipboard) {
        this.clipboard.listener.destroy();
      }
    },
    methods: {
      ...mapActions([
        'getCredentials',
      ]),
      ...mapMutations([
        'setLoading',
      ]),
      refresh() {
        this.setLoading(true);
        const APP_ID = this.$route.params.id;
        this.getCredentials(APP_ID).then((result) => {
          this.credentials = result;
          this.setLoading(false);
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .mainContent {
    display: flex;
    gap: 50px;
    flex-direction: column;

    &__clipboard {
      display: flex;
      align-items: center;
      gap: 20px;

      h1 {
        font-weight: bold;
      }
    }

    &__input {
      width: 20rem;
    }

    &__data {
      display: flex;
      gap: 20px;
      flex-direction: column;
      width: 500px;

      & > * {
        display: flex;
        align-items: center;
        gap: 10px;
        justify-content: space-between;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/ScShowCredentials.vue?4dca933e